// @ts-nocheck
import skipNavigationBlocker from "@store/Framework/Common/Utilities/skipNavigationBlocker";
import { useEffect } from "react";

let isInstalled = false;
let isReloading = false;

// Installed once per page and never restored: restoring could remove wrappers other scripts added after ours.
const installFetchGuard = () => {
    if (isInstalled) {
        return;
    }

    isInstalled = true;
    const previousFetch = window.fetch;

    window.fetch = async (...args) => {
        const response = await previousFetch(...args);

        // Maintenance mode: MaintenanceModeGuardMiddleware rejects writes and page navigation with this 400. Reload to show the maintenance page.
        if (response.status === 400 && response.headers.get("X-Maintenance-Mode") === "true") {
            if (!isReloading) {
                isReloading = true;
                skipNavigationBlocker();
                window.location.reload();
            }

            // Never settle: the caller must not run its error handling (error page, error logs) while the page reloads.
            return new Promise<Response>(() => {});
        }

        return response;
    };
};

/** Single place that watches every fetch response and reacts to specific conditions. */
const useFetchGuard = () => {
    useEffect(installFetchGuard, []);
};

export default useFetchGuard;
